/* Bella Cucina · Memorial Menu
 * View switching, hash deep-linking, share modal, print, scroll memory.
 * Recipe data lives in DOM template nodes rendered server-side by Liquid.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.mmInitialized === '1') return;
    root.dataset.mmInitialized = '1';

    var viewMenu      = root.querySelector('.mm-view-menu');
    var viewRecipe    = root.querySelector('.mm-view-recipe');
    var masthead      = root.querySelector('.mm-masthead');
    var mastheadStats = root.querySelector('.mm-stats-bar.mm-masthead-stats');
    var shareOverlay  = root.querySelector('.mm-share-overlay');
    var shareThumb    = root.querySelector('.mm-share-thumb');
    var shareType     = root.querySelector('.mm-share-type');
    var shareDishName = root.querySelector('.mm-share-dish-name');
    var toast         = root.querySelector('.mm-toast');
    var templatesHost = root.querySelector('.mm-recipe-templates');

    if (!viewMenu || !viewRecipe || !templatesHost) return;

    // Build an ordered list of recipe ids from the templates host.
    var templates = Array.prototype.slice.call(templatesHost.querySelectorAll('[data-mm-recipe-id]'));
    var orderedIds = templates.map(function (t) { return t.getAttribute('data-mm-recipe-id'); });

    var scrollMemory = 0;
    var currentRecipeId = null;
    var currentShareType = null;

    /* ─────────── recipe detail render ─────────── */
    function renderRecipe(id) {
      var tpl = templatesHost.querySelector('[data-mm-recipe-id="' + cssEsc(id) + '"]');
      if (!tpl) return false;
      var idx = orderedIds.indexOf(id);
      var prevId = idx > 0 ? orderedIds[idx - 1] : null;
      var nextId = idx < orderedIds.length - 1 ? orderedIds[idx + 1] : null;

      var navLabel    = tpl.getAttribute('data-mm-nav-label')    || '';
      var titlePlain  = tpl.getAttribute('data-mm-title-plain')  || '';
      var prevTitle   = prevId ? (templatesHost.querySelector('[data-mm-recipe-id="' + cssEsc(prevId) + '"]').getAttribute('data-mm-title-plain') || '') : '';
      var nextTitle   = nextId ? (templatesHost.querySelector('[data-mm-recipe-id="' + cssEsc(nextId) + '"]').getAttribute('data-mm-title-plain') || '') : '';

      var navHtml =
        '<nav class="mm-recipe-nav">' +
          '<button class="mm-recipe-nav-back" type="button" data-mm-back>← Back to the Menu</button>' +
          '<span class="mm-recipe-nav-center"><em>' + escapeHtml(navLabel) + '</em></span>' +
          '<div class="mm-recipe-nav-prev-next">' +
            (prevId ? '<button type="button" data-mm-open="' + escapeAttr(prevId) + '">← ' + escapeHtml(prevTitle) + '</button>' : '<span></span>') +
            (nextId ? '<button type="button" data-mm-open="' + escapeAttr(nextId) + '">' + escapeHtml(nextTitle) + ' →</button>' : '') +
          '</div>' +
        '</nav>';

      var upNextHtml;
      if (nextId) {
        var nextTpl = templatesHost.querySelector('[data-mm-recipe-id="' + cssEsc(nextId) + '"]');
        var nextPreviewImg = nextTpl.querySelector('[data-mm-preview-image] img');
        var nextNavLabel   = nextTpl.getAttribute('data-mm-nav-label') || '';
        var nextTagline    = nextTpl.getAttribute('data-mm-tagline')   || '';
        var nextTitleNode  = nextTpl.querySelector('[data-mm-title-html]');
        var nextShortDesc  = (nextTpl.querySelector('[data-mm-short-description]') || {}).innerHTML || '';
        upNextHtml =
          '<section class="mm-up-next" tabindex="0" data-mm-open="' + escapeAttr(nextId) + '">' +
            '<div class="mm-up-next-meta">' +
              '<span>Up Next · ' + escapeHtml(nextNavLabel) + '</span>' +
              '<span class="mm-un-center">' + escapeHtml(nextTagline) + '</span>' +
              '<span class="mm-un-right">' + (idx + 2) + ' of ' + orderedIds.length + ' →</span>' +
            '</div>' +
            '<div class="mm-up-next-card">' +
              '<div class="mm-up-next-image">' + (nextPreviewImg ? nextPreviewImg.outerHTML : '') + '</div>' +
              '<div>' +
                '<h4 class="mm-up-next-title">' + (nextTitleNode ? nextTitleNode.innerHTML : '') + '</h4>' +
                '<p class="mm-up-next-description">' + nextShortDesc + '</p>' +
                '<span class="mm-up-next-cta">Read the next recipe →</span>' +
              '</div>' +
            '</div>' +
          '</section>';
      } else {
        upNextHtml =
          '<section class="mm-menu-return">' +
            '<p class="mm-menu-return-text">The menu is complete.<br>Pour another glass.</p>' +
            '<span class="mm-menu-return-script">Buon appetito!</span>' +
            '<button type="button" class="mm-menu-return-btn" data-mm-back>Back to the Menu</button>' +
          '</section>';
      }

      // Clone the rendered detail template and wrap with nav + up next.
      var detail = tpl.querySelector('[data-mm-detail]');
      var detailHtml = detail ? detail.innerHTML : '';
      viewRecipe.innerHTML = navHtml + detailHtml + upNextHtml;
      return true;
    }

    /* ─────────── view switching ─────────── */
    function openRecipe(id) {
      if (!renderRecipe(id)) return;
      if (!viewMenu.hidden) scrollMemory = window.scrollY;
      currentRecipeId = id;
      viewMenu.hidden = true;
      viewRecipe.hidden = false;
      if (masthead) masthead.hidden = true;
      if (mastheadStats) mastheadStats.hidden = true;
      window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
      try { history.replaceState(null, '', '#recipe-' + id); } catch (e) {}
    }

    function closeRecipe() {
      viewRecipe.hidden = true;
      viewRecipe.innerHTML = '';
      viewMenu.hidden = false;
      if (masthead) masthead.hidden = false;
      if (mastheadStats) mastheadStats.hidden = false;
      currentRecipeId = null;
      window.scrollTo({ top: scrollMemory, behavior: 'instant' in window ? 'instant' : 'auto' });
      try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) {}
    }

    /* ─────────── share / print ─────────── */
    function buildShareText(id, type) {
      var tpl = templatesHost.querySelector('[data-mm-recipe-id="' + cssEsc(id) + '"]');
      if (!tpl) return '';
      var title    = tpl.getAttribute('data-mm-title-plain') || '';
      var accent   = tpl.getAttribute('data-mm-title-accent') || '';
      var heading  = (title + ' ' + accent).trim();
      var ingList  = tpl.querySelectorAll('[data-mm-ingredients] li');
      var lines = [];
      lines.push(heading);
      lines.push('Bella Cucina · Memorial Day Menu');
      lines.push('');
      lines.push('SHOPPING LIST');
      for (var i = 0; i < ingList.length; i++) {
        var li = ingList[i];
        if (li.classList.contains('mm-sub-header')) {
          lines.push('');
          lines.push(li.textContent.trim());
          lines.push('');
        } else {
          var q = li.querySelector('.mm-ing-qty');
          var it = li.querySelector('.mm-ing-item');
          var qty = q ? q.textContent.trim() : '';
          var item = it ? it.textContent.trim() : li.textContent.trim();
          lines.push('· ' + (qty ? qty + ' ' : '') + item);
        }
      }
      if (type === 'full') {
        lines.push('');
        lines.push('PREPARATION');
        var steps = tpl.querySelectorAll('[data-mm-method] li');
        for (var j = 0; j < steps.length; j++) {
          var step = steps[j];
          var t = step.querySelector('.mm-method-title');
          var b = step.querySelector('.mm-method-body');
          lines.push('');
          lines.push(String(j + 1).padStart(2, '0') + '. ' + (t ? t.textContent.trim().toUpperCase() : ''));
          lines.push(b ? b.textContent.trim() : '');
        }
        lines.push('');
        lines.push('Buon appetito!');
        lines.push('bellacucina.com');
      } else {
        lines.push('');
        lines.push('Full recipe: ' + window.location.origin + window.location.pathname + '#recipe-' + id);
      }
      return lines.join('\n');
    }

    function openShare(id, type) {
      currentRecipeId = id;
      currentShareType = type;
      var tpl = templatesHost.querySelector('[data-mm-recipe-id="' + cssEsc(id) + '"]');
      if (!tpl || !shareOverlay) return;
      var title = tpl.getAttribute('data-mm-title-plain') || '';
      var previewImg = tpl.querySelector('[data-mm-preview-image] img');
      if (shareType) shareType.textContent = type === 'grocery' ? 'Send Grocery List' : 'Send Full Recipe';
      if (shareDishName) shareDishName.textContent = title;
      if (shareThumb && previewImg) shareThumb.src = previewImg.currentSrc || previewImg.src;
      shareOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeShare() {
      if (!shareOverlay) return;
      shareOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    function handleShare(method) {
      var text = buildShareText(currentRecipeId, currentShareType);
      var tpl = templatesHost.querySelector('[data-mm-recipe-id="' + cssEsc(currentRecipeId) + '"]');
      var title = tpl ? (tpl.getAttribute('data-mm-title-plain') || '') : '';
      var subject = currentShareType === 'grocery' ? 'Grocery List: ' + title : 'Recipe: ' + title;
      if (method === 'text') {
        if (navigator.share) {
          navigator.share({ title: subject, text: text }).then(closeShare, function (err) {
            if (err && err.name === 'AbortError') return;
            window.location.href = 'sms:?body=' + encodeURIComponent(text);
            closeShare();
          });
          return;
        }
        window.location.href = 'sms:?body=' + encodeURIComponent(text);
        closeShare();
      } else if (method === 'email') {
        window.location.href = 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(text);
        closeShare();
      } else if (method === 'copy') {
        copyToClipboard(text).then(function () {
          showToast('Copied to clipboard');
          closeShare();
        });
      } else if (method === 'print') {
        printRecipe(currentRecipeId, currentShareType);
        closeShare();
      }
    }

    function copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
      return new Promise(function (resolve) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        resolve();
      });
    }

    function printRecipe(id, type) {
      var tpl = templatesHost.querySelector('[data-mm-recipe-id="' + cssEsc(id) + '"]');
      if (!tpl) return;
      var title  = tpl.getAttribute('data-mm-title-plain')  || '';
      var accent = tpl.getAttribute('data-mm-title-accent') || '';
      var eyebrow = tpl.getAttribute('data-mm-eyebrow') || '';
      var description = (tpl.querySelector('[data-mm-description]') || {}).textContent || '';
      var ingredientsRaw = tpl.querySelector('[data-mm-ingredients]');
      var methodRaw      = tpl.querySelector('[data-mm-method]');

      var ingHtml = '';
      if (ingredientsRaw) {
        Array.prototype.forEach.call(ingredientsRaw.children, function (li) {
          if (li.classList.contains('mm-sub-header')) {
            ingHtml += '<li style="list-style:none;font-style:italic;color:#666;margin-top:14px;padding-bottom:4px;">' + escapeHtml(li.textContent.trim()) + '</li>';
          } else {
            var q = li.querySelector('.mm-ing-qty');
            var it = li.querySelector('.mm-ing-item');
            ingHtml += '<li style="padding:6px 0;border-bottom:1px dotted #ccc;list-style:none;">' +
                       '<strong style="display:inline-block;width:90px;font-size:11px;letter-spacing:0.15em;text-transform:uppercase;color:#5A6B40;">' + escapeHtml(q ? q.textContent.trim() : '') + '</strong> ' +
                       (it ? it.innerHTML : '') +
                       '</li>';
          }
        });
      }

      var methodHtml = '';
      if (type === 'full' && methodRaw) {
        Array.prototype.forEach.call(methodRaw.children, function (li, i) {
          var t = li.querySelector('.mm-method-title');
          var b = li.querySelector('.mm-method-body');
          methodHtml +=
            '<li style="margin-bottom:20px;list-style:none;padding-left:50px;position:relative;">' +
              '<span style="position:absolute;left:0;top:0;font-family:Georgia,serif;font-size:11px;letter-spacing:0.15em;color:#5A6B40;font-weight:500;">' + String(i + 1).padStart(2, '0') + '</span>' +
              '<strong style="display:block;font-family:Georgia,serif;font-size:10px;letter-spacing:0.25em;text-transform:uppercase;color:#5A6B40;margin-bottom:6px;">' + escapeHtml(t ? t.textContent.trim() : '') + '</strong>' +
              (b ? b.innerHTML : '') +
            '</li>';
        });
      }

      var printContent =
        '<div style="font-family:Georgia,serif;max-width:760px;margin:0 auto;padding:40px;color:#1A1612;">' +
          '<p style="font-family:Georgia,serif;font-size:11px;letter-spacing:0.3em;text-transform:uppercase;color:#5A6B40;margin-bottom:16px;text-align:center;">— ' + escapeHtml(eyebrow) + ' —</p>' +
          '<h1 style="font-style:italic;font-weight:500;font-size:36px;line-height:1.1;margin-bottom:14px;text-align:center;">' + escapeHtml(title) + ' <span style="color:#3F4D2D;">' + escapeHtml(accent) + '</span></h1>' +
          '<p style="font-style:italic;text-align:center;color:#666;margin-bottom:32px;font-size:14px;">' + escapeHtml(description.trim()) + '</p>' +
          '<h2 style="font-family:Georgia,serif;font-size:11px;letter-spacing:0.3em;text-transform:uppercase;color:#5A6B40;margin-top:32px;margin-bottom:16px;padding-bottom:8px;border-bottom:1px solid #999;">Shopping List</h2>' +
          '<ul style="padding-left:0;list-style:none;">' + ingHtml + '</ul>' +
          (type === 'full'
            ? '<h2 style="font-family:Georgia,serif;font-size:11px;letter-spacing:0.3em;text-transform:uppercase;color:#5A6B40;margin-top:32px;margin-bottom:16px;padding-bottom:8px;border-bottom:1px solid #999;">Preparation</h2><ol style="padding-left:0;">' + methodHtml + '</ol>'
            : '') +
          '<p style="font-family:Georgia,serif;font-style:italic;font-size:32px;color:#3F4D2D;text-align:center;margin-top:48px;">Buon appetito!</p>' +
          '<p style="font-family:Georgia,serif;font-size:10px;letter-spacing:0.3em;text-transform:uppercase;color:#999;text-align:center;margin-top:16px;">Bella Cucina · bellacucina.com</p>' +
        '</div>';

      var w = window.open('', '_blank');
      if (!w) return;
      w.document.write('<!DOCTYPE html><html><head><title>' + escapeHtml(title) + '</title><style>body{margin:0;padding:0;background:white;}@media print{body{-webkit-print-color-adjust:exact;}}</style></head><body>' + printContent + '</body></html>');
      w.document.close();
      setTimeout(function () { w.print(); }, 500);
    }

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('show');
      setTimeout(function () { toast.classList.remove('show'); }, 2400);
    }

    /* ─────────── helpers ─────────── */
    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function escapeAttr(s) { return escapeHtml(s); }
    function cssEsc(s) {
      if (window.CSS && CSS.escape) return CSS.escape(s);
      return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
    }

    /* ─────────── delegate clicks ─────────── */
    root.addEventListener('click', function (e) {
      var openTarget = e.target.closest('[data-mm-open]');
      if (openTarget) {
        e.preventDefault();
        openRecipe(openTarget.getAttribute('data-mm-open'));
        return;
      }
      if (e.target.closest('[data-mm-back]')) {
        e.preventDefault();
        closeRecipe();
        return;
      }
      var shareBtn = e.target.closest('[data-mm-share]');
      if (shareBtn) {
        e.preventDefault();
        openShare(shareBtn.getAttribute('data-mm-recipe'), shareBtn.getAttribute('data-mm-share'));
        return;
      }
      var printBtn = e.target.closest('[data-mm-print]');
      if (printBtn) {
        e.preventDefault();
        printRecipe(printBtn.getAttribute('data-mm-recipe'), printBtn.getAttribute('data-mm-print'));
        return;
      }
      var optBtn = e.target.closest('[data-mm-share-method]');
      if (optBtn) {
        e.preventDefault();
        handleShare(optBtn.getAttribute('data-mm-share-method'));
        return;
      }
      if (e.target.closest('[data-mm-share-close]')) {
        e.preventDefault();
        closeShare();
        return;
      }
      if (shareOverlay && e.target === shareOverlay) {
        closeShare();
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var openTarget = e.target.closest('[data-mm-open]');
        if (openTarget && openTarget.tagName !== 'BUTTON' && openTarget.tagName !== 'A') {
          e.preventDefault();
          openRecipe(openTarget.getAttribute('data-mm-open'));
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (shareOverlay && shareOverlay.classList.contains('open')) closeShare();
        else if (!viewRecipe.hidden) closeRecipe();
      }
    });

    // Hide the SMS share option on desktop browsers without navigator.share.
    if (!navigator.share && !/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
      var smsBtn = root.querySelector('[data-mm-share-method="text"]');
      if (smsBtn) smsBtn.style.display = 'none';
    }

    // Initial hash routing.
    var hash = window.location.hash;
    if (hash.indexOf('#recipe-') === 0) {
      var id = hash.replace('#recipe-', '');
      if (templatesHost.querySelector('[data-mm-recipe-id="' + cssEsc(id) + '"]')) {
        openRecipe(id);
      }
    }
    window.addEventListener('hashchange', function () {
      var h = window.location.hash;
      if (h.indexOf('#recipe-') === 0) {
        var id2 = h.replace('#recipe-', '');
        if (id2 !== currentRecipeId) openRecipe(id2);
      } else if (!viewRecipe.hidden) {
        closeRecipe();
      }
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-memorial-menu]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when sections are re-rendered by the Shopify theme editor.
  document.addEventListener('shopify:section:load',   boot);
  document.addEventListener('shopify:section:select', boot);
})();
